import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ADMIN_ROLES = ["admin", "super_admin", "dispatch_manager", "finance_admin", "operations_manager", "support"];

// Admin routes redirect to dedicated /admin/login, customer/rider routes redirect to /login
const loginPathFor = (allowedRoles) =>
  allowedRoles && allowedRoles.some((r) => ADMIN_ROLES.includes(r)) ? "/admin/login" : "/login";

// allowedRoles: array of roles permitted, e.g. ["user"], ["rider"], ["admin"]
export default function ProtectedRoute({ allowedRoles, children }) {
  const { account } = useAuth();
  const loginPath = loginPathFor(allowedRoles);
  if (!account) return <Navigate to={loginPath} replace />;
  if (allowedRoles && !allowedRoles.includes(account.role)) {
    return <Navigate to={loginPath} replace />;
  }
  return children;
}
